import Genova1 from '../../Media/Ruko/Genova.webp'
import Genova2 from '../../Media/Ruko/Genova.webp'


const Genovaimages =[
Genova1,Genova2
]

export default Genovaimages;